module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8540/img/spiderweb-corner.png"